export default __webpack_public_path__ + "static/media/Group 9552.54727808.svg";